import { render, staticRenderFns } from "./pc-upload.vue?vue&type=template&id=69c8690a&scoped=true&"
import script from "./pc-upload.vue?vue&type=script&lang=ts&"
export * from "./pc-upload.vue?vue&type=script&lang=ts&"
import style0 from "./pc-upload.vue?vue&type=style&index=0&id=69c8690a&lang=less&scoped=true&"
import style1 from "./pc-upload.vue?vue&type=style&index=1&id=69c8690a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8690a",
  null
  
)

export default component.exports